import React, { FC } from 'react'

import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import DispensingOptions from './DispensingOptions'

export interface DispensingOptionsSectionProps {
  settings: PractitionerSettings
}

const DispensingOptionsSection: FC<DispensingOptionsSectionProps> = ({ settings }) => {
  return (
    <div>
      <DispensingOptions settings={settings} />
    </div>
  )
}

export default DispensingOptionsSection
